export default "__VITE_ASSET__Cc_6Pdrv__"